import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginAwareComponent } from '../login-aware-component';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { GraphClientService } from '../services/graph-client-service';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

/**
 * Shown only to anonymous users, this component renders group sales cards on
 * screen, sourcing them from an Excel file uploaded to a SharePoint Online document library.
 * The cards are not real-time, unlike what the title says. In actuality the Excel file is
 * updated about once a month or so.
 */
@Component({
  selector: 'app-group-sales',
  templateUrl: './group-sales.component.html',
  styleUrls: ['./group-sales.component.scss']
})
export class GroupSalesComponent extends LoginAwareComponent implements OnInit, OnDestroy {
  private groupSaleCards: any[];

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    authService: MsalService,
    private graphClient: GraphClientService) {
    super(diagnosticsFactory.create('GroupSalesComponent'), broadcastService, authService);
    this.groupSaleCards = [];
  }

  ngOnInit() {
    super.ngOnInit();
    this.setValues();
  }

  private setValues() {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
      const dynamicData  = data as any;

      if (dynamicData.values && dynamicData.values.length > 0 ) {
        this.groupSaleCards = dynamicData.values;
      } else {
        this.diagnostics.logError(`Data returned by service is in unexpected format.`);
      }
    }, error => {
      this.diagnostics.logError(`Failed to get data from service.`);
    });
  }

  private getValue(rowIndex: number, columnIndex: number) {
    if (rowIndex >= this.groupSaleCards.length) {
      return null;
    }

    const item = this.groupSaleCards[rowIndex] as any[];

    if (!item || columnIndex >= item.length) {
      return null;
    }

    return item[columnIndex];
  }
}
